import { createSvgComponent } from "../../icon/createSvgComponent";
import Notification from "@core/__generated__/icon/figma/notification.svg";
export default createSvgComponent(Notification);